import React, { useState, type FC } from 'react';
import { Link, useParams } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { RecommendModal } from '@pages/shop/recommend-modal';
import { ShareProductNew } from '@shared/assets';
import { useUser } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';
import type { Product } from 'library/models/shop';
import Price from './frames/Price';
import styles from './ProductCard.module.scss';

interface Props {
  product: Product;
}

const ProductCard: FC<Props> = ({ product }) => {
  const { isAuth } = useUser();
  const { code } = useParams<{ code: string }>();

  const link = `/shop/${code}/products/product/${product.id}`;

  const [showModal, setShowModal] = useState(false);

  return (
    <li className={styles.productCard}>
      <Link className={styles.image} to={{ pathname: link }}>
        <ImageWithSkeleton src={product.promo_image} alt={product.title} className={styles.img} />
        {/*<img src={product.promo_image} alt={product.title} className={styles.img} />*/}
      </Link>
      <Link to={{ pathname: link }} className={styles.title}>
        <header>{product.title}</header>
      </Link>
      <div className={styles.footer}>
        <Link to={{ pathname: link }} className={styles.price}>
          <Price
            price={product.current_price}
            partnerPrice={product.partner_price && product.partner_price.partner_amount}
          />
        </Link>
        {isAuth && (
          <Tooltip title="Рекомендовать" disableInteractive>
            <IconButton variant="dark" onClick={() => setShowModal(true)}>
              <ShareProductNew />
            </IconButton>
          </Tooltip>
        )}
        {showModal && (
          <RecommendModal
            toggleModal={setShowModal}
            recommend={link}
            productTitle={product.title}
          />
        )}
      </div>
    </li>
  );
};

export default ProductCard;
